<template>
	<range-slider
		class="slider"
		:min="rangeMin"
		:max="rangeMax"
		:step="rangeStep"
		v-model="rangeValue">
	</range-slider>
</template>
 
<script>
import {mapState, mapGetters} from 'vuex';
import RangeSlider from 'vue-range-slider'
import 'vue-range-slider/dist/vue-range-slider.css'
/* eslint-disable vue/no-unused-components */
export default {
	name: "ab_test",
	data () {
		return {
		}
	},
	components: {
		RangeSlider
	},
	computed:{
		rangeValue: {
			get() {
				return this.summVuex;
			},
			set(value) {
				let saveSumm = this.summVuex;
				this.$store.dispatch('setDealStateRange', {type: 'SelectedSumm', value: value});
				this.$store.dispatch('saveSendData', {target: 'CALC_SUMM', value: value});
				if (this.FixedPay ==0 ) {
					this.$store.dispatch('setDealStateRange', {type: 'SelectedSumm', value: saveSumm});
					this.$store.dispatch('saveSendData', {target: 'CALC_SUMM', value: saveSumm})
				}
			}
		},
		...mapState({
			//rangeMin: state => state.Deal.MinSumm,
			rangeMin: state => state.Deal.minBaseProduct.Amount,
			rangeMax: state => state.Deal.MaxSumm,
			rangeStep: state => state.Deal.StepSumm,
			summVuex: state => state.Deal.SelectedSumm,
		}),
		...mapGetters(['FixedPay']),
	}
}
</script> 
 
<style scope>
.slider { width: 100%; box-sizing: border-box; padding: 0; }
.slider .range-slider-hidden { display: none; }
.slider .range-slider-rail { background-color: #43AC34; }
.slider .range-slider-fill { background-color: #0C5A44; }
.slider .range-slider-knob { border: 0.1rem solid #0D5740; background-color: #0D5740; box-shadow: inset 0 0 0 0.13rem white; width: 1.04rem; height: 1.04rem; }
.range-slider-rail, .range-slider-fill { height: .2rem; }
@media (max-width: 768px) {
	.slider .range-slider-knob { box-shadow: inset 0 0 0 .05rem white; width: .6rem; height: .6rem; }
	.range-slider-rail, .range-slider-fill { height: .1rem; }
}
</style> 